import { Injectable } from '@angular/core';
import { ToastInitConfig, ToastInsideConfig, ToastPositions, ToastResponse } from '../toast.config';
import { BehaviorSubject, concatMap, delay, map, Observable, of, Subject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToasService {
  count: number = 0
  private aAllToast: { [key: string]: ToastInsideConfig } = {}
  private ToastSubject$ = new BehaviorSubject<{ [key: string]: ToastInsideConfig }>(this.aAllToast)
  toastObs = this.ToastSubject$.asObservable()
  private responseToast: { [key: string]: ToastResponse } = {}
  private toastResponseSubject$ = new BehaviorSubject<{ [key: string]: ToastResponse }>(this.responseToast)
  responseObs = this.toastResponseSubject$.asObservable()
  private closeAllToast$ = new BehaviorSubject<boolean>(false)
  closeAllToastObs = this.closeAllToast$.asObservable()

  constructor() { }

  updateToastData(toastData: ToastInsideConfig) {
    this.aAllToast[toastData.count!] = toastData
    this.ToastSubject$.next(this.aAllToast)
  }

  async deleteToast(toastData: ToastInsideConfig) {
    let response: ToastResponse = { isChecked: toastData.isChecked, confirmRedirection: toastData.confirmRedirection }
    this.responseToast[toastData.count!] = response
    this.toastResponseSubject$.next(this.responseToast)
    delete this.responseToast[toastData.count!]
    this.toastResponseSubject$.next(this.responseToast)
    delete this.aAllToast[toastData.count!]
    this.ToastSubject$.next(this.aAllToast)
  }

  async closeAllToast() {
    this.aAllToast = {};
    this.responseToast = {};
    this.count = 0; 
    
    this.ToastSubject$.next({});
    this.toastResponseSubject$.next({});
  }

  init(toastData: ToastInitConfig): Observable<ToastResponse> {
    let id = this.count;
    this.count++;
    toastData.position = toastData.position || 'top-r';
    this.aAllToast[id] = { ...toastData, bMostrar: true, count: id, positionCss: ToastPositions[toastData.position] }
    this.ToastSubject$.next(this.aAllToast);
    return this.responseObs.pipe(
      map(resp => resp[id] || {})
    );
  }
}
